<template>
  <div class="footer">
    <div class="footer__first-line justify-content-between">
      <div class="footer__processed">
        <AmTypography
          :text="$t('containerLeft.footer.paymentBy')"
          data-test="teste"
          typography-style="l8"
        />
        <img
          class="footer__logo"
          src="/img/appmax-logo.svg"
          alt="appmax-logo"
        />
      </div>
      <div class="d-flex">
        <div class="pr-2">
          <a
            class="link"
            href="https://appmax.com.br/termos-de-uso"
            target="_blank"
          >
            <AmTypography
              :text="$t('containerLeft.footer.terms')"
              typography-style="l8"
            />
          </a>
        </div>
        <div>
          <a
            class="link"
            href="https://appmax.com.br/politica-de-privacidade"
            target="_blank"
          >
            <AmTypography
              :text="$t('containerLeft.footer.policy')"
              typography-style="l8"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AmFooter',
}
</script>

<style lang="scss" scoped>
::v-deep {
  .am-typography > .l8 {
    font-size: 10px;
  }
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: auto;

  &__first-line {
    display: flex;
    justify-content: center;
    gap: 38px;
    width: 60%;
    margin: 33px 0 0 0;
    text-align: center;
    border-top: 0;
    padding: 0 16px 8px;

    @include mobile {
      width: 100%;
      gap: 18px;
      background: $white;
      position: fixed;
      padding-top: 8px;
      border-top: 1px solid #d2d6de;
      bottom: 0;
    }

    @include desktop {
      width: auto;
    }
  }

  &__processed {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__logo {
    margin: 0;
  }
}
</style>
